import { Chip } from "@mui/material";
import { PIPELINE_INSTANCE_STATUS } from "../../../constants";
import PropTypes from "prop-types";
import { getPipelineStatus } from "../../utils";

export function StatusChip({ status }) {
    const { Icon, title, color } = getPipelineStatus(status);
    return <Chip icon={<Icon />} label={title} color={color} size="small" />;
}

StatusChip.propTypes = {
    status: PropTypes.oneOf(Object.values(PIPELINE_INSTANCE_STATUS)),
};
